import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

type UseAureusImpressionTracking = () => (options: {
  aureusOfferId?: string
  smart?: string
  isRecommendation?: boolean
}) => void

const useAureusImpressionTracking: UseAureusImpressionTracking = () => {
  const queryClient = useQueryClient()

  const triggerAureusImpression = useCallback(
    ({ aureusOfferId, smart, isRecommendation }: any) => {
      if (aureusOfferId) {
        if (
          isRecommendation &&
          !queryClient.getQueryData('aureusRecommendationOfferTracked')
        ) {
          queryClient.setQueryData('aureusRecommendationOfferTracked', true)
          window.dlApi.cmd.push((dlApi: any) => {
            dlApi.registerAureusOffers([aureusOfferId])
          })
        } else if (
          smart?.includes('top') &&
          !queryClient.getQueryData('aureusOfferTracked')
        ) {
          queryClient.setQueryData('aureusOfferTracked', true)
          window.dlApi.cmd.push((dlApi: any) => {
            dlApi.registerAureusOffers([aureusOfferId])
          })
        }
      }
    },
    [queryClient]
  )

  return triggerAureusImpression
}

export default useAureusImpressionTracking
